module.exports = __webpack_public_path__ + "img/VEC-logo.c53d2090.svg";